var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 28,
    r: 28,
    fill: "#FAA42A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.0609 13C20.0916 13.5998 21.1194 14.2046 22.1534 14.7987C29.9896 19.3012 37.8271 23.8015 45.664 28.3027C45.7594 28.3575 45.8532 28.415 46 28.5024C37.0039 33.6695 28.043 38.8163 19.018 44C19.018 43.8174 19.018 43.6925 19.018 43.5678C19.018 33.4988 19.0181 23.4297 19.0173 13.3608C19.0173 13.2404 19.006 13.1203 19 13C19.0203 13 19.0406 13 19.0609 13ZM21.4454 39.8324C28.0345 36.0472 34.5804 32.2868 41.1749 28.4985C34.5696 24.7043 28.0231 20.9437 21.4454 17.1653C21.4454 24.7386 21.4454 32.2526 21.4454 39.8324Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/play.2b3e30cb1d674eaf8d928e46367862b5.svg";
export { ForwardRef as ReactComponent };